import { useCallback } from "react"
import { router } from "expo-router"
import { useAddLoan } from "@/queries/loan"
import { showErrorToast } from "@/components/toasts/AppToast"
import { useBottomSheetModal } from "@gorhom/bottom-sheet"
import { $selectedCompDetailId } from "@/stores/compsDataStore"

import { getRouteForNewLoan } from "@/screens/loans/utils/LoanUtils"

export function useCreateLoan(analysisId: string) {
  const { mutate: addLoanMutation, isPending } = useAddLoan()
  const { dismissAll } = useBottomSheetModal()

  const createLoan = useCallback(() => {
    addLoanMutation(
      { analysisId },
      {
        onSuccess: (data) => {
          const loanApplication = data?.createLoanApplication?.loanApplication
          if (loanApplication) {
            $selectedCompDetailId.set(null)
            dismissAll()
            router.dismissAll()
            router.push(getRouteForNewLoan(loanApplication))
          }
        },
        onError: (err) => {
          console.error(err)
          showErrorToast({
            title: "Loan Failed",
            message: err.message,
          })
        },
      }
    )
  }, [analysisId, addLoanMutation, dismissAll])

  return {
    createLoan,
    isPending,
  }
}
